import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export default function TypingIndicator() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      className="flex items-end gap-3"
    >
      {/* AI Avatar */}
      <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-violet-600 via-fuchsia-600 to-pink-500 text-white shadow-lg">
        <Sparkles size={18} />
      </div>

      {/* Typing Bubble */}
      <div className="rounded-3xl rounded-bl-md border border-white/10 bg-white/10 px-3 py-2 backdrop-blur-xl shadow-lg">
        <div className="flex items-center gap-1.5">

          <motion.span
            animate={{ y: [0, -5, 0] }}
            transition={{ repeat: Infinity, duration: 0.6, delay: 0 }}
            className="h-2 w-2 rounded-full bg-violet-400"
          />

          <motion.span
            animate={{ y: [0, -5, 0] }}
            transition={{ repeat: Infinity, duration: 0.6, delay: 0.2 }}
            className="h-2.5 w-2.5 rounded-full bg-fuchsia-400"
          />

          <motion.span
            animate={{ y: [0, -5, 0] }}
            transition={{ repeat: Infinity, duration: 0.6, delay: 0.4 }}
            className="h-2 w-2 rounded-full bg-pink-400"
          />

        </div>

        <p className="mt-2 text-[11px] text-white/70">
          GrowX AI is typing...
        </p>
      </div>
    </motion.div>
  );
}